// 9fbef606107a605d69c0edbcd8029e5d
import HEADER_CONSTANTS from './Header.constants';

const initailState = {
  miniBag: false,
  cartItemCount: 0,
  updateCartCount: false,
  isL1PanelOpen: false,
  isUpdateSBPEvent: false,
  accountDrawerOpen: false,
  hideDrawerInfoSection: false,
};

const HeaderReducer = (state = initailState, action) => {
  switch (action.type) {
    case HEADER_CONSTANTS.LOAD_HEADER_DATA:
      return { ...state, ...action.payload };
    case HEADER_CONSTANTS.OPEN_NAVIGATION_DRAWER:
      return {
        ...state,
        navigationDrawer: { open: action.payload, close: false },
      };
    case HEADER_CONSTANTS.CLOSE_NAVIGATION_DRAWER:
      return {
        ...state,
        navigationDrawer: { close: true, open: false },
        hideDrawerInfoSection: false,
      };
    case HEADER_CONSTANTS.HIDE_DRAWER_INFO_SECTION:
      return {
        ...state,
        hideDrawerInfoSection: action.payload,
      };
    case HEADER_CONSTANTS.CLOSE_MINI_BAG:
      return {
        ...state,
        miniBag: false,
      };
    case HEADER_CONSTANTS.OPEN_MINI_BAG:
      return {
        ...state,
        miniBag: true,
      };
    case HEADER_CONSTANTS.CART_ITEM_COUNT:
      return {
        ...state,
        cartItemCount: action.payload,
      };
    case HEADER_CONSTANTS.UPDATE_CART_MANUALLY:
      return {
        ...state,
        updateCartCount: action.payload,
      };

    case HEADER_CONSTANTS.REMOVE_L1_PANEL_TIMEOUT:
      return state.isL1PanelOpen
        ? state
        : {
            ...state,
            isL1PanelOpen: true,
          };
    case HEADER_CONSTANTS.UPDATE_SBP_EVENT:
      return {
        ...state,
        isUpdateSBPEvent: action.payload,
      };
    case HEADER_CONSTANTS.SET_CONDENSED_STATUS:
      return {
        ...state,
        isCondensedHeader: action.payload,
      };
    case HEADER_CONSTANTS.OPEN_ACCOUNT_DRAWER:
      return {
        ...state,
        accountDrawerOpen: true,
      };
    case HEADER_CONSTANTS.CLOSE_ACCOUNT_DRAWER:
      return {
        ...state,
        accountDrawerOpen: false,
      };
    default:
      return state;
  }
};

export default HeaderReducer;
